import AddToCartButton from "./add-to-cart-button";

const InitAddToCartButtons = (selector = '[sh-add-to-cart]') => {
  const elements = document.querySelectorAll(selector);
  if (typeof (elements) !== 'undefined' && elements.length > 0) {
    elements.forEach(el => {
      let $btn = AddToCartButton(el);
    })
  }
}

export default InitAddToCartButtons;
